module.exports = __webpack_public_path__ + "static/media/temperature-frigid.a9b0a5b0.svg";